import React from "react";
import { createTheme, responsiveFontSizes, Theme, ThemeProvider } from "@mui/material/styles";
import customTheme from "./theme";
import { deepmerge } from "@mui/utils";

const defaultTheme = createTheme();
const baseTheme = responsiveFontSizes(defaultTheme);

declare module "@mui/styles" {
  interface DefaultTheme extends Theme {}
}

declare module "@mui/material/styles" {
  interface Theme {}
  // allow configuration using `createTheme`
  interface ThemeOptions {}
}

export type ThemeType = typeof customTheme;
const newTheme = createTheme(deepmerge(baseTheme, customTheme));

type RootElementProps = {
  children?: React.ReactNode;
};

export const CustomThemeProvider = ({ children }: RootElementProps) => {
  return <ThemeProvider theme={newTheme}>{children}</ThemeProvider>;
};
